<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M5.24967 12.8332V10.4998H8.74968V12.8332M4.66634 3.49984H4.67217M9.33301 3.49984H9.33884M6.99967 3.49984H7.00551M6.99967 5.83317H7.00551M6.99967 8.1665H7.00551M9.33301 5.83317H9.33884M9.33301 8.1665H9.33884M4.66634 5.83317H4.67217M4.66634 8.1665H4.67217M3.49967 1.1665H10.4997C11.144 1.1665 11.6663 1.68884 11.6663 2.33317V11.6665C11.6663 12.3108 11.144 12.8332 10.4997 12.8332H3.49967C2.85534 12.8332 2.33301 12.3108 2.33301 11.6665V2.33317C2.33301 1.68884 2.85534 1.1665 3.49967 1.1665Z"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
